import { mainstore } from "../../store";
import axios from 'axios';

class APICom {
    static MainAPIURL = "";
    static AspDotNetCoreURL = "";
    static GenericManifestDotNetCoreURL = "";
    static GenericReportingURL = ""
    static ReservationCoreURL = "";
    static _EXTERNAL_DISPATCH_API = "";
    static LastGridCall = new Date();
    static cache = new Map();
    static GenerateSource(){
        return axios.CancelToken.source();
    }
    static delay(ms) {
        return new Promise(resolve => setTimeout(resolve, ms));
    }
    static async fetchData(urltype = "", path = "/", type = "get", headers = { "Content-Type": "application/json" }, data = {}, xSource = null, WebWorker = false, opts = {}, responseType = '') {
        try{
            if (opts != null && opts.hasOwnProperty('CacheTime') && Number.isInteger(opts.CacheTime) && opts.CacheTime > 0) {
                let cacheKey = JSON.stringify({ urltype, path, type, data });
                let now = Date.now();
                // Remove expired entries from cache
                for (let [key, value] of this.cache) {
                    if (value.expiry <= now) {
                        this.cache.delete(key);
                    }
                }
                // Check if the request is already in the cache
                if (this.cache.has(cacheKey)) {
                    const cachedEntry = this.cache.get(cacheKey);
                    if (cachedEntry.expiry > now) {
                        return cachedEntry.returnObject;
                    } 
                    else {
                        this.cache.delete(cacheKey); // Remove expired entry
                    }
                }
            }
        }
        catch(e) { }
        var returnObject = {
            error: "",
            data: "",
        }
        try {
            if(this.AspDotNetCoreURL === "")
            {
                this.AspDotNetCoreURL = mainstore.getState().configuration.AspDotNetCoreURL; 
            }
            if(this.GenericManifestDotNetCoreURL === "")
            {
                this.GenericManifestDotNetCoreURL = mainstore.getState().configuration.GenericManifestDotNetCoreURL; 
            }
            if (this.MainAPIURL === "") {
                this.MainAPIURL = mainstore.getState().configuration.MainAPIURL;
            }
            if(this.ReservationCoreURL === "")
            {
                this.ReservationCoreURL = mainstore.getState().configuration.ReservationCoreURL;
            }
            if(this.GenericReportingURL === "")
            {
                this.GenericReportingURL = mainstore.getState().configuration.GenericReportingURL;
            }
            if(this._EXTERNAL_DISPATCH_API === "")
            {
                this._EXTERNAL_DISPATCH_API = mainstore.getState().configuration.EXTERNAL_DISPATCH_API;
            }
        }
        catch (p) { }
        try {
            var URLT = ""
            switch (urltype) {
                case "": URLT = this.MainAPIURL + path; break;
                case "main": URLT = this.MainAPIURL + path; break;
                case "AspDotNetCoreURL": URLT = this.AspDotNetCoreURL + path; break;
                case "GenericManifestDotNetCoreURL": URLT = this.GenericManifestDotNetCoreURL + path; break;
                case "GenericReportingURL": URLT = this.GenericReportingURL + path; break;
                case "ReservationCoreURL": URLT = this.ReservationCoreURL + path; break;
                case "EXTERNAL_DISPATCH_API": URLT = this._EXTERNAL_DISPATCH_API + path; break;
                case "full": URLT = path; break;
                default: URLT = urltype + path; break;
            }
            if(WebWorker === true){
                if (type === "get") {
                    let config = {};
                    if(xSource !== null){
                        config = {
                            cancelToken: xSource.token
                        };
                    }
                    let res = await axios.get(URLT, config);
                    returnObject.data = res.data;
                }
                else if (type === "post") {
                    let config = {};
                    let retData = null;
                    config.headers = headers;
                    if(xSource !== null){
                        config.cancelToken = xSource.token;
                        xSource.token.promise.then(function(e){
                            retData = "Error: Request was cancelled from calling code."
                        });
                    }
                    let itercount = 0;
                    let workerBlob = new Blob(
                        [
                            `self.onmessage = (e) => {
                                try {
                                    const xhr = new XMLHttpRequest();
                                    xhr.open('POST', e.data.url, false); // false for synchronous request
                                    xhr.setRequestHeader('Content-Type', 'application/json');
                                    xhr.send(JSON.stringify(e.data.payload));
                                    if (xhr.status === 200) {
                                        let lpdata = xhr.responseText;
                                        if(lpdata.charAt(0) == '[' || lpdata.charAt(0) == '{'){
                                            self.postMessage(JSON.parse(lpdata));
                                        }
                                        else{
                                            self.postMessage(lpdata);
                                        }
                                    //self.postMessage(xhr.responseText);
                                    } else {
                                    self.postMessage('Error: ' + xhr.status);
                                    }
                                }
                                catch(er) {
                                    self.postMessage('Error: ' + er);
                                }
                              };`
                        ],
                        { type: 'application/javascript' }
                      );
                    let workerUrl = URL.createObjectURL(workerBlob);
                    let ComWorker = new Worker(workerUrl);
                    ComWorker.addEventListener('message', event => {
                        //event.data
                        if(retData === null) {
                            retData = event.data;
                        }
                    });
                    ComWorker.postMessage({"url": URLT, "payload":data});
                    while(retData === null && itercount <= 480){
                        await this.delay(250);
                        itercount = itercount + 1
                    }
                    if(retData === null) {
                        retData = "Error: No response received from server (Web Worker)."
                    }
                    ComWorker.terminate();
                    if(typeof retData === 'string' &&retData.indexOf("Error") > -1) {
                        returnObject.error = retData;
                    }
                    else {
                        returnObject.data = retData;
                    }

                }
            }
            else{
                if (type === "get") {
                    let config = {};
                    if(xSource !== null){
                        config = {
                            cancelToken: xSource.token
                        };
                    }
                    config.headers = headers;
                    //const res = await fetch(URL);
                    //returnObject.data = await res.json();
                    let res = await axios.get(URLT, config);
                    returnObject.data = res.data;
                }
                if (type === "get2") {
                    let config = {};
                    if(xSource !== null){
                        config = {
                            cancelToken: xSource.token
                        };
                    }
                    const defaultAuthHeader = "Basic QkFSV09PRDpiYXJ3b29kcGFzcw==";
                 
                    config.headers = headers || {};

                    
                    if (!config.headers.get("Authorization")) {
                        config.headers.Authorization = defaultAuthHeader;
                    }

                    let res = await axios.get(URLT, {headers:{'Content-Type': 'application/json', "Authorization": config.headers.get("Authorization")}});
                    returnObject.data = res.data;
                }
                else if (type === "post") {
                    let config = {};
                    let responseFetch = (responseType !== '' ? responseType : '')
                    config.headers = headers;
                    if(responseFetch !== '')
                        config.responseType = responseFetch;
                    if(xSource !== null){
                        config.cancelToken = xSource.token;
                    }
                    let response = await axios.post(URLT, data, config);
                    //const res = await fetch(URL, {
                    //    method: "POST", // *GET, POST, PUT, DELETE, etc.
                    //    mode: "cors", // no-cors, *cors, same-origin
                    //    cache: "no-cache", // *default, no-cache, reload, force-cache, only-if-cached
                    //    credentials: "same-origin", // include, *same-origin, omit
                    //    headers: headers,
                    //    redirect: "follow", // manual, *follow, error
                    //    referrerPolicy: "no-referrer", // no-referrer, *no-referrer-when-downgrade, origin, origin-when-cross-origin, same-origin, strict-origin, strict-origin-when-cross-origin, unsafe-url
                    //    body: JSON.stringify(data), // body data type must match "Content-Type" header
                    //});
                    returnObject.data = response.data;//await res.json();

                }
            }
        } catch (error) {
            if(typeof error ===  "object" ){
                if(typeof error.code != "undefined"){
                    if(error.code === "ERR_NETWORK"){
                        returnObject.error = "Could not connect to the endpoint. (" + error.message + ")";
                    }
                    else if(typeof error.message === "string") {
                        returnObject.error = error.message;
                    }
                    else{
                        returnObject.error = "Unknown error occurred while fetching the data from the endpoint";
                    }
                }
                else if(typeof error.message === "string") {
                    returnObject.error = error.message;
                }
                else{
                    returnObject.error = "Unknown error occurred while fetching the data from the endpoint";
                }
            }
            else{
                returnObject.error = error;
            }
        }
        try
        {
            if (opts != null && opts.hasOwnProperty('CacheTime') && Number.isInteger(opts.CacheTime) && opts.CacheTime > 0 && returnObject.error === "") {
                let cacheKey = JSON.stringify({ urltype, path, type, data });
                let now = Date.now();
                this.cache.set(cacheKey, {
                    returnObject,
                    expiry: now + opts.CacheTime * 1000 // CacheTime in seconds converted to milliseconds
                  });
            }
        }
        catch(e) { }
        return returnObject;
    };
    static fetchDataSync(urltype = "", path = "/", type = "get", headers = { "Content-Type": "application/json" }, data = {}) {
        var returnObject = {
            error: "",
            data: "",
        }
        try {
            if(this.AspDotNetCoreURL === "")
            {
                this.AspDotNetCoreURL = mainstore.getState().configuration.AspDotNetCoreURL; 
            }
            if (this.MainAPIURL === "") {
                this.MainAPIURL = mainstore.getState().configuration.MainAPIURL;
            }
        }
        catch (p) { }
        try {
            var URL = ""
            switch (urltype) {
                case "": URL = this.MainAPIURL + path; break;
                case "main": URL = this.MainAPIURL + path; break;
                case "full": URL = path; break;
                case "AspDotNetCoreURL": URL = this.AspDotNetCoreURL + path; break;
                default: URL = this.MainAPIURL + path; break;
            }
            if (type === "get") {
                let response = axios.post(URL, data);
                returnObject.data = response.data;
            }
            else if (type === "post") {
                let response = axios.post(URL, data);
                returnObject.data = response.data;

            }
        } catch (error) {
            returnObject.error = error;
        }
        return returnObject;
    };
};

export default APICom;